import axios from 'axios';
import useUtils from '../../components/hooks/useUtils';
const { doCopy } = useUtils();


const state = {
	status: 0,
	inbox: 0,
	labels: {types: {}, chanels: {}, titles: {}, prios: {}, statuses: {} },
	validator: {},
	ticketHistory: [],
	success: false,
	loading: false,
	message: "",
}

const mutations = {
	UPDATE_STATUS(state, payload) {
		state.status = payload;
	},
	UPDATE_INBOX(state, payload) {
		state.inbox = payload;
	},
	UPDATE_LOADING(state) {
		setLoadingState(state);
	},
	UPDATE_TICKETS_HISTORY(state, payload) {
		if (payload.success) {
			setSuccessState(state, payload.message);
			state.ticketHistory = payload.data;
		} else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_STATE(state, payload) {
		if (payload.success) {
			setSuccessState(state, payload.message);
		} else {
			setErrorState(state, payload.message);
		}
	},
	UPDATE_TYPES(state, payload) {
		state.labels.types = doCopy(payload);
	},
	UPDATE_CHANELS(state, payload) {
		state.labels.chanels =doCopy(payload);
	},
	UPDATE_TITLES(state, payload) {
		state.labels.titles =doCopy(payload);
	},
	UPDATE_PRIOS(state, payload) {
		state.labels.prios = doCopy(payload);
	},
	UPDATE_STATUSES(state, payload) {
		state.labels.statuses =doCopy(payload);
	},
	UPDATE_VALIDATOR(state, payload) {
		state.validator = payload;
	},
	UPDATE_ERROR(state, payload) {
		setErrorState(state, payload);
	},
}

const actions = {
	loadTicketHistory({ commit }, id) {
		commit('UPDATE_LOADING');
		axios
		.get("/tickets/history/" + id).then((response) => {
			commit('UPDATE_TICKETS_HISTORY', response.data);
		})
		.catch(function(error) {
			commit('UPDATE_ERROR', error);
		});
	},
	resetTicketHistory({ commit }) {
		const payload={success: true, data: [], message: ""};
		commit('UPDATE_TICKETS_HISTORY', payload);
	}
}

const getters = {
	ticketHistory: state => state.ticketHistory,
	inbox: state => state.inbox,
	status: state => state.status,
	validator: state => state.validator,
	labels: state => state.labels,
	success: state => state.success,
	loading: state => state.loading,
	message: state => state.message,
}

function setLoadingState(state) {
	state.success = false;
	state.loading = true;
	state.message = "";
}

function setSuccessState(state, message = "") {
	state.success = true;
	state.loading = false;
	state.message = message;
}

function setErrorState(state, message = "") {
	state.success = false;
	state.loading = false;
	state.message = message;
}

const ticketsModule = {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
}

export default ticketsModule;